import React, { useEffect } from "react";

const useGetHeightPage = () => {
    const [height, setHeight] = React.useState(0);

    useEffect(() => {
    const sendHeight = () => {
        const height = document.body.querySelector(".page-content")?.offsetHeight;
        window.parent.postMessage({ iframeHeight: height }, "*");
        setHeight(height);
    };

    setTimeout(() => {        
        sendHeight();
    }, 1000);

    // Envia também quando a janela é redimensionada ou o conteúdo muda
    window.addEventListener("load", sendHeight);

    return () => {
        window.removeEventListener("load", sendHeight);
    };
    }, []);

    return height
}

export default useGetHeightPage